"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
var Business = {
  initStep: false,
  taskHash: '',
  calculatorVersion: '',
  map: undefined,
  pointStart: undefined,
  pointFinish: undefined,
  distance: {
    distance: 0,
    distanceText: '',
    duration: 0,
    durationText: '',
    locationFrom: '',
    locationTo: '',
    routeCenter: {
      lng: '',
      lat: ''
    }
  },
  onload: document.addEventListener('DOMContentLoaded', function () {
    Business.init();
  }),
  init: function init() {
    this.bind();
    this.initMap();
    this.InitDateTimePicker();
    if (Business.initStep) {
      Business.calculateWidthForTabLine();
      Business.ajax.getBusinessPaymentData(Business.taskHash);
      var latFrom = $('[name="businessLatFrom"]').val();
      var lngFrom = $('[name="businessLngFrom"]').val();
      var latTo = $('[name="businessLatTo"]').val();
      var lngTo = $('[name="businessLngTo"]').val();
      Business.pointStart = {
        lat: parseFloat(latFrom),
        lng: parseFloat(lngFrom)
      };
      Business.pointFinish = {
        lat: parseFloat(latTo),
        lng: parseFloat(lngTo)
      };
      Business.calcRoute();
    }
  },
  bind: function bind() {
    $(document).on('click', '.business-step-next', function (event) {
      event.preventDefault();
      Main.showPreloader($(this));
      Business.ajax.validateStep($(this));
    }).on('click', '.business-step-prev', function (event) {
      event.preventDefault();
      Business.switchSteps($(this), false);
    }).on('click', '.business-steps-tab', function (event) {
      event.preventDefault();
      if ($(this).hasClass('done')) {
        Business.switchTabs($(this));
      }
    }).on('click', '.init-map-info', function () {
      var id = $(this).attr('data-id');
      var latFrom = $(this).attr('data-lat-from');
      var lngFrom = $(this).attr('data-lng-from');
      var latTo = $(this).attr('data-lat-to');
      var lngTo = $(this).attr('data-lng-to');
      Business.pointStart = {
        lat: parseFloat(latFrom),
        lng: parseFloat(lngFrom)
      };
      Business.pointFinish = {
        lat: parseFloat(latTo),
        lng: parseFloat(lngTo)
      };
      Business.calcRoute(id);
    });
    $(document).on('click', '.checkbox-services', function () {
      var driverSelect = $(this).closest('.select-services');
      var blockWithSelectedItems = driverSelect.find('.selected-items');
      var blockWithSelectedItemsTips = $('.selected-services-tips');
      var dataId = $(this).attr('id');
      if ($(this).is(':checked')) {
        var title = $(this).next().html();
        var html = "<div class=\"selected-items-item\" data-item-id=\"".concat(dataId, "\">").concat(title, "<svg data-id=\"").concat(dataId, "\" width=\"12\" height=\"11\" viewBox=\"0 0 12 11\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M1 0.5L6 5.5M11 10.5L6 5.5M6 5.5L11 0.5M6 5.5L1 10.5\" stroke=\"white\" stroke-linecap=\"round\" /></svg></div>");
        var tipsHtml = "<p data-item-id=\"".concat(dataId, "\">").concat(title, "</p>");
        blockWithSelectedItems.prepend(html);
        blockWithSelectedItemsTips.prepend(tipsHtml);
      } else {
        blockWithSelectedItems.find("[data-item-id=\"".concat(dataId, "\"]")).remove();
        blockWithSelectedItemsTips.find("[data-item-id=\"".concat(dataId, "\"]")).remove();
      }
      Driver.setSelectJson(driverSelect);
      $(this).closest('.select-services__wrapper').removeClass('error').find('.select-services__error').html('');
    }).on('click', '.services', function () {
      $('.services--list').addClass('active');
    }).on('click', '.selected-items-item svg', function () {
      var dataId = parseInt($(this).attr('data-id'));
      $("#" + dataId).prop('checked', false);
      $(this).closest('div').remove();
      $('.selected-services-tips').find("[data-item-id=\"".concat(dataId, "\"]")).remove();
      var driverSelect = $(this).closest('.select-services');
      Driver.setSelectJson(driverSelect);
    }).on('click', '.select-services__btn', function () {
      if ($(this).closest('.select-services').find('.select-services__info').hasClass("select-services__info--active")) {
        $('.select-services__info').removeClass("select-services__info--active");
        $('.select-services__selects').slideUp("hide");
      } else {
        $(this).closest('.select-services').find('.select-services__selects').slideDown("show");
        $(this).closest('.select-services').find('.select-services__info').addClass("select-services__info--active");
      }
    }).on('click', function (e) {
      if (!$(e.target).closest(".select-services__wrapper").length) {
        $('.select-services__selects').slideUp("hide");
        $('.select-services__info').removeClass("select-services__info--active");
      }
      if (!$(e.target).closest(".select-languages__wrapper").length) {
        $('.select-languages__selects').slideUp("hide");
        $('.select-languages__info').removeClass("select-languages__info--active");
      }
      if (!$(e.target).closest(".header--right").length) {
        $('.services--list').removeClass('active');
      }
      if (!$(e.target).closest('.header-business-center--item').length) {
        $('.hover-menu').removeClass('active');
        $('.header-business-center--item').removeClass('active');
      }
      e.stopPropagation();
    }).on('click', '[data-scroll]', function (e) {
      e.preventDefault();
      var element = $('#' + $(this).attr('data-scroll'));
      if (element.length > 0) {
        Step.scrollToElement(element);
      } else {
        Step.scrollToElement($('#' + $(this).attr('data-scroll-additional')));
      }
      if (innerWidth <= 550) {
        document.querySelector('.header-business-mobile').classList.remove('active');
        document.querySelector('body').classList.remove('body-hidden');
        document.querySelector('.toggle-menu').classList.remove('active');
      }
    }).on('paste change', '.calculate-amount-for-business', function (event) {
      setTimeout(function () {
        Business.ajax.calculateAmountForBusiness();
      }, 250);
    }).on('click', '.select-vehicle-size', function () {
      setTimeout(function () {
        Business.ajax.calculateAmountForBusiness();
      }, 100);
    }).on('click', 'button.copy-coupon-code', function (e) {
      e.preventDefault();
      var notify = $(this).attr('data-notify');
      var data = $(this).text().trim();
      var input = $("<input>");
      $("body").append(input);
      input.val(data).select();
      document.execCommand("copy");
      input.remove();
      Notify.successfulNotification(notify);
    }).on('click', '.header-business-center--item', function (e) {
      $('.header-business-center--item').removeClass('active');
      $('.header-business-center--item').find('.hover-menu').removeClass('active');
      $(this).addClass('active');
      $(this).find('.hover-menu').addClass('active');
      console.log("click");
    });
    $(document).on('change', '[name="businessHelpHours"]', function () {
      $('.hours-data-tips').text($(this).val());
    }).on('change', '[name="businessExtraHelpers"]', function () {
      $('.helpers-data-tips').text($(this).val());
    }).on('click', '.back-to-business-calculator', function (e) {
      e.preventDefault();
      Business.manageAuthForm();
    }).on('click', '.business-calculator-auth-next', function (e) {
      e.preventDefault();
      Business.switchLoginSteps($(this));
    }).on('click', '.business-calculator-close-verification-step', function (e) {
      e.preventDefault();
      $('[name="SignupForm[code]"]').attr('name', 'SignupForm[codeDisabled]');
      $('.sign-up-step-1').show();
      $('.sign-up-step-2').hide();
    }).on('change', '[name="business-auth-user-role"]', function (e) {
      e.preventDefault();
      if ($(this).is(':checked')) {
        $(this).closest('div[data-step]').find('.business-calculator-auth-next').prop('disabled', false);
      }
    });
    var receiveOfferPopup = document.querySelector('.receive-offer');
    var receiveOfferPopupClose = document.querySelectorAll('.receive-offer__close');
    receiveOfferPopupClose.forEach(function (item) {
      item.addEventListener('click', function () {
        receiveOfferPopup.style.display = "none";
      });
    });
    $('#business-login-form').on('beforeSubmit', function () {
      var $loginForm = $(this);
      $.ajax({
        type: $loginForm.attr('method'),
        url: $loginForm.attr('action') + '?returnTypeData=1',
        data: $loginForm.serializeArray()
      }).done(function (data) {
        data = JSON.parse(data);
        if (data.result) {
          Business.manageAuthForm();
          $('.step--item[data-step="32"]').find('.business-step-next').click();
        } else {
          $('#loginform-password').next().text(data.error);
        }
      }).fail(function () {
        return false;
      });
      return false;
    });
    $('#business-signup-form').on('beforeSubmit', function () {
      var $signUpForm = $(this);
      $.ajax({
        type: $signUpForm.attr('method'),
        url: $signUpForm.attr('action') + '?returnTypeData=1',
        data: $signUpForm.serializeArray()
      }).done(function (data) {
        data = JSON.parse(data);
        if (data.result) {
          if (data.neededEmailVerification) {
            $('[name="SignupForm[codeDisabled]"]').attr('name', 'SignupForm[code]');
            $('.sign-up-step-1').hide();
            $('.sign-up-step-2').show();
            Step.scrollToElement($('.new-calculator'), 0);
          } else {
            Business.manageAuthForm();
            $('.step--item[data-step="32"]').find('.business-step-next').click();
          }
        }
        $('#signupform-email').next().text(data.error);
        $('[name="SignupForm[code]"]').next().text(data.error);
      }).fail(function () {
        return false;
      });
      return false;
    });
    $(document).on('click', '.attach-files--button', function (e) {
      e.preventDefault();
      Business.selectFiles($(this));
    }).on('click', '.remove-upload-business-task-photo', function (e) {
      e.preventDefault();
      Business.files.remove($(this).closest('li[data-id]').data('id'));
      $('.attach-files--button').show();
    }).on('click', '.remove-uploaded-business-task-file', function (e) {
      e.preventDefault();
      var id = $(this).attr('data-id');
      var block = $(this).closest('div');
      Step.ajax.removeUploadedFile(id, block);
    });
  },
  InitDateTimePicker: function InitDateTimePicker() {
    var date = $('#business-date').flatpickr({
      dateFormat: 'd.m.Y H:i',
      enableTime: true,
      allowInput: false,
      minDate: new Date().fp_incr(1),
      minTime: "06:00",
      startTime: "06:00",
      time_24hr: true,
      disableMobile: "true"
    });
  },
  initPaymentStep: function initPaymentStep(data) {
    Payment.type = data.type;
    Payment.amount = data.amount;
    Payment.bonus = data.bonus;
    Payment.payableNow = data.payableNow;
    Payment.payoutOption = data.payoutOption;
    Payment.serviceType = data.serviceType;
    Payment.serviceID = data.serviceID;
    Payment.stripePaymentIntent = data.stripePaymentIntent;
    Payment.stripePublishableKey = data.stripePublishableKey;
    Payment.callbackUrlForSofort = data.callbackUrlForSofort;
    Payment.payButton = '#book-business-task';
    ++Payment.initCounter;
    Payment.init();
  },
  initMap: function initMap() {
    var _Business$pointStart;
    var mapId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'business-map';
    var location = (_Business$pointStart = Business.pointStart) !== null && _Business$pointStart !== void 0 ? _Business$pointStart : {
      lat: 52.518505,
      lng: 13.403806
    };
    var styles = [{
      "featureType": "administrative",
      "elementType": "labels.text.fill",
      "stylers": [{
        "color": "#444444"
      }]
    }, {
      "featureType": "landscape",
      "elementType": "all",
      "stylers": [{
        "color": "#f2f2f2"
      }]
    }, {
      "featureType": "poi",
      "elementType": "all",
      "stylers": [{
        "visibility": "off"
      }]
    }, {
      "featureType": "road",
      "elementType": "all",
      "stylers": [{
        "saturation": -100
      }, {
        "lightness": 45
      }]
    }, {
      "featureType": "road.highway",
      "elementType": "all",
      "stylers": [{
        "visibility": "simplified"
      }]
    }, {
      "featureType": "road.arterial",
      "elementType": "labels.icon",
      "stylers": [{
        "visibility": "off"
      }]
    }, {
      "featureType": "transit",
      "elementType": "all",
      "stylers": [{
        "visibility": "off"
      }]
    }, {
      "featureType": "water",
      "elementType": "all",
      "stylers": [{
        "color": "#1f3470"
      }, {
        "visibility": "on"
      }, {
        "saturation": "0"
      }, {
        "lightness": "51"
      }]
    }];
    if (document.getElementById(mapId)) {
      Business.map = new google.maps.Map(document.getElementById(mapId), {
        scaleControl: true,
        center: location,
        zoom: 10,
        styles: styles,
        mapId: 'fc147a215044ba81',
        panControlOptions: {
          position: google.maps.ControlPosition.TOP_RIGHT
        },
        zoomControlOptions: {
          position: google.maps.ControlPosition.TOP_RIGHT
        }
      });
    }
  },
  calcRoute: function calcRoute() {
    var mapId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'business-map';
    Business.initMap(mapId);
    var route = {
      origin: Business.pointStart,
      destination: Business.pointFinish,
      travelMode: 'DRIVING'
    };
    var marker1 = new google.maps.Marker({
      position: Business.pointStart,
      map: Business.map
    });
    var marker2 = new google.maps.Marker({
      position: Business.pointFinish,
      map: Business.map
    });
    var directionsService = new google.maps.DirectionsService();
    var directionsRenderer = new google.maps.DirectionsRenderer();
    directionsRenderer.setMap(Business.map); // Existing map object displays directions
    // Create route from existing points used for markers

    directionsService.route(route, function (response, status) {
      // anonymous function to capture directions
      if (status !== 'OK') {
        // window.alert('Directions request failed due to ' + status);
        return;
      } else {
        console.log(response);
        directionsRenderer.setDirections(response); // Add route to the map

        var directionsData = response.routes[0].legs[0]; // Get data about the mapped route

        if (!directionsData) {
          // window.alert('Directions request failed');
          return;
        } else {
          Business.distance = {
            distance: directionsData.distance.value,
            distanceText: directionsData.distance.text,
            duration: directionsData.duration.value,
            durationText: directionsData.duration.text,
            locationFrom: directionsData.start_address,
            locationTo: directionsData.end_address,
            routeCenter: response.routes[0].bounds.getCenter()
          };
          $('[name="businessDistance"]').val(Business.distance.distance);
          $('[name="businessDistanceInfo"]').val(Business.distance.distanceText + ' (' + Business.distance.durationText + ')');
          Business.setTips();
        }
      }
    });
  },
  manageAuthForm: function manageAuthForm() {
    var open = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var forms = $('.new-calculator--content');
    if (open) {
      forms.first().show();
      forms.last().hide();
    } else {
      forms.first().hide();
      forms.last().show();
    }
  },
  setTips: function setTips() {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var fromToRight, distanceLabel, _yield$google$maps$im, AdvancedMarkerElement, map, marker;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            fromToRight = $('.from-to--right');
            fromToRight.find('.from').text($('#business-calculator-location-from').val());
            fromToRight.find('.to').text($('#business-calculator-location-to').val());
            fromToRight.find('.distance').text($('[name="businessDistanceInfo"]').val());
            $('.info--item-vehicle').find('.description').text($('[name="businessVehicleSize"]').closest('div').find('.select__current').text().trim());
            distanceLabel = document.createElement("div");
            distanceLabel.className = "business-distance-map-label";
            distanceLabel.textContent = Business.distance.distanceText;
            _context.next = 10;
            return google.maps.importLibrary("marker");
          case 10:
            _yield$google$maps$im = _context.sent;
            AdvancedMarkerElement = _yield$google$maps$im.AdvancedMarkerElement;
            map = Business.map;
            marker = new AdvancedMarkerElement({
              map: map,
              position: Business.distance.routeCenter,
              content: distanceLabel
            });
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  calculateWidthForTabLine: function calculateWidthForTabLine() {
    var width = ((parseInt($('.done').length) + 1) * 33.33).toFixed(2);
    $('.step-new__progress-bar--four').css('width', width + '%');
  },
  switchTabs: function switchTabs(tab) {
    var navBarItems = $('.step-new__line');
    navBarItems.removeClass('activeBusinessStep').removeClass('done');
    var form = $('.new-calculator--content').last();
    var currentStep = tab.attr('data-step');
    form.find('.step--item').removeClass('active');
    form.find(".step--item[data-step=\"".concat(currentStep, "\"]")).addClass('active');
    var step = $('.new-calculator--content').last().find('div[data-step].active').attr('data-step');
    navBarItems.each(function () {
      if (parseInt($(this).attr('data-step')) < parseInt(step)) {
        $(this).addClass('done');
      }
      if (parseInt($(this).attr('data-step')) === parseInt(step)) {
        $(this).addClass('activeBusinessStep');
      }
    });
    Business.calculateWidthForTabLine();
    Step.scrollToElement($('.new-calculator'), 0);
  },
  switchSteps: function switchSteps(button) {
    var next = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var stepDiv = button.closest('div[data-step]');
    var navBarItems = $('.step-new__line');
    navBarItems.removeClass('activeBusinessStep').removeClass('done');
    $('.new-calculator--content').last().find('.step--item').removeClass('active');
    var currentStepDiv;
    if (next) {
      currentStepDiv = stepDiv.next();
      currentStepDiv.addClass('active');
    } else {
      currentStepDiv = stepDiv.prev();
      currentStepDiv.addClass('active');
    }
    var step = $('.new-calculator--content').last().find('div[data-step].active').attr('data-step');
    navBarItems.each(function () {
      if (parseInt($(this).attr('data-step')) < parseInt(step)) {
        $(this).addClass('done');
      }
      if (parseInt($(this).attr('data-step')) === parseInt(step)) {
        $(this).addClass('activeBusinessStep');
      }
    });
    Business.calculateWidthForTabLine();
    Step.scrollToElement($('.new-calculator'), 0);
    if (parseInt(step) === 33) {
      Business.ajax.saveBusinessForm();
    }
  },
  switchLoginSteps: function switchLoginSteps(button) {
    var stepDiv = button.closest('div[data-step]');
    var step = stepDiv.attr('data-step');
    $('#form-business-login').find('.step--item').removeClass('active');
    if (step === '1') {
      if (Business.calculatorVersion === '2') {
        $('.step--item[data-step="3"]').addClass('active');
      } else {
        if ($('[name="business-auth-user-role"]:checked').val() === '2') {
          $('.step--item[data-step="4"]').addClass('active');
        } else {
          $('.step--item[data-step="3"]').addClass('active');
        }
      }
    } else if (step === '2') {
      var stepLogin = button.attr('data-step');
      $(".step--item[data-step=\"".concat(stepLogin, "\"]")).addClass('active');
    } else if (step === '3') {
      $('.step--item[data-step="2"]').addClass('active');
    } else if (step === '4') {
      $('.step--item[data-step="3"]').addClass('active');
    }
    Step.scrollToElement($('.new-calculator'), 0);
  },
  selectFiles: function selectFiles(element) {
    var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;
    Business.$form = element.closest('form');
    var $input = $('<input type="file" accept=".png, .jpg, .jpeg, .HEIC, .xlsx, .csv, .docx, .pdf, .mov, .mp4" multiple>').on('change', function (event) {
      var fileName = this.files[0];
      var fileNameExt = fileName.name.substr(fileName.name.lastIndexOf('.') + 1);
      var preloaderCount = true;
      if (fileNameExt == "heic" || fileNameExt == "HEIC") {
        var thisInput = this;
        preloaderCount = false;

        // Step.preloaderUpload(event, preloaderCount);

        heic2any({
          blob: fileName,
          toType: "image/jpeg",
          quality: 0.5
        }).then(function (result) {
          var container = new DataTransfer();
          var fileJpeg = new File([result], fileName.name + ".jpg", {
            type: "image/jpeg",
            lastModified: new Date().getTime()
          });
          container.items.add(fileJpeg);
          $.each(thisInput.files, function (k) {
            if (fileJpeg.size < Business.maxFileSize && Driver.files.list.length < max) {
              Business.files.add(container.files[0]);
              // Step.previewFiles.push(URL.createObjectURL(result));
            }
          });
        })["catch"](function (x) {
          console.log('Error');
        });
      } else {
        // preloaderCount = true;

        // Step.preloaderUpload(event, preloaderCount);

        $.each(this.files, function (k, v) {
          if (v.size < Step.maxFileSize && Business.files.list.length < max) {
            Business.files.add(v);
            // Step.previewFiles.push(URL.createObjectURL(event.target.files[k]));
          }
        });
      }

      $input.remove();
      if (Business.files.list.length > max - 1) {
        $('.attach-files--button').hide();
      } else {
        $('.attach-files--button').show();
      }

      // $('.upload-photo').removeClass('error');
      // $('.upload-photo__error').html('');
    }).hide();
    $(document.body).append($input);
    $input.click();
  },
  files: {
    list: [],
    $fileList: undefined,
    $progress: undefined,
    add: function add(file) {
      this.list.push(file);
      this.refreshList();
    },
    remove: function remove(key) {
      this.list.splice(key, 1);
      Step.previewFiles.splice(key, 1);
      this.refreshList();
    },
    refreshList: function refreshList(callback) {
      this.$fileList = $('.files').fadeOut('fast', function () {
        $(this).children('.files--item[data-id]').remove();
        $.each(Business.files.list, function (k, v) {
          Business.files.$fileList.append($('<div class="files--item">').attr('data-id', k).append($('<span>').text(Business.files.list[k].name)).append('<svg class="remove-upload-business-task-photo" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 2L7 7M12 12L7 7M7 7L12 2M7 7L2 12" stroke="#333333" stroke-linecap="round"/></svg>'));
        });
        $(this).fadeIn('fast', function () {
          typeof callback === 'function' ? callback() : null;
        });
      });
    },
    upload: function upload() {
      if (this.list.length > 0) {
        Business.ajax.uploadFilesForBusinessTask(this.list.shift());
      } else {
        // if (Step.postTaskAsGuest) {
        //     window.location.replace(Step.callbackUrl);
        // } else {
        //     let thankYouPage = $('div.thank-form-step');
        //     let thankYouPageWrapper = $('div.thank-form-step-wrapper');
        //
        //     thankYouPageWrapper.css('display', 'block');
        //     thankYouPage.css('display', 'flex');
        //
        //     $('div.offer__container').hide();
        //
        //     $('.need-fast-offer').addClass('active');
        //
        //     Step.scrollToTop();
        // }
      }
    }
  },
  ajax: {
    obj: {},
    url: AJAX_URL,
    send: function send(success, failure) {
      var _this = this;
      $.post(this.url, this.obj, function (answer) {
        _this.obj = {};
        answer.result && typeof success === 'function' ? success(answer) : !answer.result && typeof failure === 'function' ? failure(answer) : null;
      }, 'JSON');
    },
    uploadFilesForBusinessTask: function uploadFilesForBusinessTask(file) {
      var formData = new FormData();
      formData.append('method', 'uploadFilesForBusinessTask');
      formData.append('id', Business.taskHash);
      formData.append('file', file);
      $.ajax({
        url: AJAX_URL,
        type: 'POST',
        data: formData,
        contentType: false,
        processData: false,
        success: function success() {
          Business.files.upload();
        },
        error: function error() {
          console.log('Error');
        }
      });
    },
    calculateAmountForBusiness: function calculateAmountForBusiness() {
      var _$$val, _$$val2, _$$val3, _$$val4, _$$val5, _$$val6, _$$val7, _$$val8, _$$val9, _$$val10, _$$val11;
      this.obj.method = 'calculateAmountForBusiness';
      this.obj.addressFrom = (_$$val = $('[name="businessAddressFrom"]').val()) !== null && _$$val !== void 0 ? _$$val : '';
      this.obj.addressTo = (_$$val2 = $('[name="businessAddressTo"]').val()) !== null && _$$val2 !== void 0 ? _$$val2 : '';
      this.obj.countryFrom = (_$$val3 = $('[name="businessCountryFrom"]').val()) !== null && _$$val3 !== void 0 ? _$$val3 : '';
      this.obj.countryTo = (_$$val4 = $('[name="businessCountryTo"]').val()) !== null && _$$val4 !== void 0 ? _$$val4 : '';
      this.obj.lngFrom = (_$$val5 = $('[name="businessLngFrom"]').val()) !== null && _$$val5 !== void 0 ? _$$val5 : '';
      this.obj.latFrom = (_$$val6 = $('[name="businessLatFrom"]').val()) !== null && _$$val6 !== void 0 ? _$$val6 : '';
      this.obj.lngTo = (_$$val7 = $('[name="businessLngTo"]').val()) !== null && _$$val7 !== void 0 ? _$$val7 : '';
      this.obj.latTo = (_$$val8 = $('[name="businessLatTo"]').val()) !== null && _$$val8 !== void 0 ? _$$val8 : '';
      this.obj.vehicleSize = (_$$val9 = $('[name="businessVehicleSize"]').val()) !== null && _$$val9 !== void 0 ? _$$val9 : 0;
      this.obj.extraHelpers = (_$$val10 = $('[name="businessExtraHelpers"]').val()) !== null && _$$val10 !== void 0 ? _$$val10 : 0;
      this.obj.helperHours = (_$$val11 = $('[name="businessHelpHours"]').val()) !== null && _$$val11 !== void 0 ? _$$val11 : 0;
      this.send(function (answer) {
        if (!answer.isAvailableLocations) {
          $('.btn-contact-us').show();
          $('.btn-first-step').hide();
          $('.price').hide();
        } else {
          $('.btn-contact-us').hide();
          $('.btn-first-step').show();
          $('.price').css('display', 'flex').find('b').text(answer.amount.max + '€');
          $('.info--price').show().find('b').text(answer.amount.max + '€');
          $('[name="businessAmount"]').val(answer.amount.max);
        }

        // $('[name="businessBudget"]').val(answer.amount);
      }, function (answer) {
        Notify.dangerNotification(answer.text);
      });
    },
    validateStep: function validateStep(button) {
      var step = button.closest('div[data-step]').attr('data-step');
      this.obj.method = 'validateStep';
      this.obj.step = step;
      this.obj.data = button.closest("div[data-step]").find(':input').serializeArray();
      this.obj.checkFiles = $('.open-image').length;
      this.send(function (answer) {
        Main.hidePreloader(button);
        Business.setTips();
        if (answer.additionalData !== undefined && answer.additionalData.loginRequire) {
          Business.manageAuthForm(true);
        } else if (step === FORM_TYPE_BUSINESS_TASK__STEP_4) {} else {
          Business.switchSteps(button, true);
        }
      }, function (answer) {
        $.each(answer.errors, function (name, value) {
          Step.showErrors(name, value);
        });
        console.table(answer.errors);
        if (Object.keys(answer.errors).length) Step.scrollToError(Object.keys(answer.errors)[0]);
        Main.hidePreloader(button);
        Business.setTips();
      });
    },
    getBusinessPaymentData: function getBusinessPaymentData(hash) {
      this.obj.method = 'getBusinessPaymentData';
      this.obj.hash = hash;
      this.send(function (answer) {
        Business.initPaymentStep(answer);
      }, function (answer) {
        console.error('Error!');
      });
    },
    saveBusinessForm: function saveBusinessForm($submitBtn) {
      var _$$val12, _$$val13, _$$val14, _$$val15, _$$val16, _$$val17, _$$val18, _$$val19, _$$val20, _$$val21, _$$val22, _$$val23, _$$val24, _$$val25, _$$val26, _$$val27, _$$val28, _$$val29, _$$val30, _$$val31, _$$val32, _$$val33, _$$val34, _$$val35, _$$val36, _$$val37, _$$val38;
      this.obj.method = 'saveBusinessForm';
      this.obj.hash = Business.taskHash;
      this.obj.data = {
        'businessAddressFrom': (_$$val12 = $('[name="businessAddressFrom"]').val()) !== null && _$$val12 !== void 0 ? _$$val12 : '',
        'businessAddressTo': (_$$val13 = $('[name="businessAddressTo"]').val()) !== null && _$$val13 !== void 0 ? _$$val13 : '',
        'businessCountryFrom': (_$$val14 = $('[name="businessCountryFrom"]').val()) !== null && _$$val14 !== void 0 ? _$$val14 : '',
        'businessCityFrom': (_$$val15 = $('[name="businessCityFrom"]').val()) !== null && _$$val15 !== void 0 ? _$$val15 : '',
        'businessCountryTo': (_$$val16 = $('[name="businessCountryTo"]').val()) !== null && _$$val16 !== void 0 ? _$$val16 : '',
        'businessCityTo': (_$$val17 = $('[name="businessCityTo"]').val()) !== null && _$$val17 !== void 0 ? _$$val17 : '',
        'businessLngFrom': (_$$val18 = $('[name="businessLngFrom"]').val()) !== null && _$$val18 !== void 0 ? _$$val18 : '',
        'businessLatFrom': (_$$val19 = $('[name="businessLatFrom"]').val()) !== null && _$$val19 !== void 0 ? _$$val19 : '',
        'businessLngTo': (_$$val20 = $('[name="businessLngTo"]').val()) !== null && _$$val20 !== void 0 ? _$$val20 : '',
        'businessLatTo': (_$$val21 = $('[name="businessLatTo"]').val()) !== null && _$$val21 !== void 0 ? _$$val21 : '',
        'businessVehicleSize': (_$$val22 = $('[name="businessVehicleSize"]').val()) !== null && _$$val22 !== void 0 ? _$$val22 : 0,
        'businessHelpServices': (_$$val23 = $('[name="businessHelpServices"]').val()) !== null && _$$val23 !== void 0 ? _$$val23 : '',
        'businessExtraHelpers': (_$$val24 = $('[name="businessExtraHelpers"]').val()) !== null && _$$val24 !== void 0 ? _$$val24 : 0,
        'businessHelpHours': (_$$val25 = $('[name="businessHelpHours"]').val()) !== null && _$$val25 !== void 0 ? _$$val25 : 0,
        'businessMinBudget': (_$$val26 = $('[name="businessMinBudget"]').val()) !== null && _$$val26 !== void 0 ? _$$val26 : 0,
        'businessMaxBudget': (_$$val27 = $('[name="businessMaxBudget"]').val()) !== null && _$$val27 !== void 0 ? _$$val27 : 0,
        'businessDescription': (_$$val28 = $('[name="businessDescription"]').val()) !== null && _$$val28 !== void 0 ? _$$val28 : '',
        'businessCompanyName': (_$$val29 = $('[name="businessCompanyName"]').val()) !== null && _$$val29 !== void 0 ? _$$val29 : '',
        'businessFirstName': (_$$val30 = $('[name="businessFirstName"]').val()) !== null && _$$val30 !== void 0 ? _$$val30 : '',
        'businessLastName': (_$$val31 = $('[name="businessLastName"]').val()) !== null && _$$val31 !== void 0 ? _$$val31 : '',
        'businessEmail': (_$$val32 = $('[name="businessEmail"]').val()) !== null && _$$val32 !== void 0 ? _$$val32 : '',
        'businessPhone': (_$$val33 = $('[name="businessPhone"]').val()) !== null && _$$val33 !== void 0 ? _$$val33 : '',
        'businessMessage': (_$$val34 = $('[name="businessMessage"]').val()) !== null && _$$val34 !== void 0 ? _$$val34 : '',
        'businessAmount': (_$$val35 = $('[name="businessAmount"]').val()) !== null && _$$val35 !== void 0 ? _$$val35 : '',
        'businessDistance': (_$$val36 = $('[name="businessDistance"]').val()) !== null && _$$val36 !== void 0 ? _$$val36 : '',
        'businessDistanceInfo': (_$$val37 = $('[name="businessDistanceInfo"]').val()) !== null && _$$val37 !== void 0 ? _$$val37 : '',
        'businessDate': (_$$val38 = $('[name="businessDate"]').val()) !== null && _$$val38 !== void 0 ? _$$val38 : ''
      };
      this.send(function (answer) {
        Business.taskHash = answer.hash;
        $('[name="billing_data_offer_id"]').val(Business.taskHash);
        Business.ajax.getBusinessPaymentData(answer.hash);
        Business.files.upload();
      }, function (answer) {
        Notify.dangerNotification(answer.text);
      });
    }
  }
};
var businessPage = document.querySelector('.business-page');
var businessPageSeo = document.querySelector('.business-seo');
if (businessPageSeo || businessPage) {
  var ourServices = new Swiper('.our-services-content', {
    lazy: true,
    wrapperClass: "our-services-wrapper",
    slideClass: "our-services-slide",
    slidesPerView: 2,
    loop: false,
    spaceBetween: 20,
    breakpoints: {
      600: {
        slidesPerView: 3
      },
      992: {
        slidesPerView: 4
      },
      1200: {
        slidesPerView: 5
      }
    },
    pagination: {
      el: '.swiper-pagination',
      dynamicBullets: true,
      dynamicMainBullets: 1
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    }
  });
}
var cardItems = document.querySelectorAll('.card--item');
if (cardItems) {
  cardItems.forEach(function (cardItem) {
    var moreButtons = cardItem.querySelectorAll('.more');
    var closePopup = cardItem.querySelectorAll('.close-popup--order');
    moreButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var cardItemPopup = cardItem.querySelector('.card--item--popup');
        if (cardItemPopup) {
          cardItemPopup.classList.toggle('active');
          var popupOrder = document.querySelector('.popup-order');
          if (popupOrder) {
            var SwiperPopupOrder = new Swiper('.popup-order-container', {
              lazy: true,
              wrapperClass: 'popup-order-wrapper',
              slideClass: 'popup-order-slide',
              slidesPerView: 2,
              loop: false,
              spaceBetween: 16,
              pagination: {
                el: '.swiper-pagination',
                dynamicBullets: true,
                dynamicMainBullets: 3
              },
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
              }
            });
            Fancybox.bind("[data-fancybox]", {});
          }
        }
        button.classList.toggle('active');
      });
    });
    closePopup.forEach(function (button) {
      button.addEventListener('click', function () {
        var cardItemPopup = cardItem.querySelector('.card--item--popup');
        if (cardItemPopup) {
          cardItemPopup.classList.remove('active');
        }
        button.classList.toggle('active');
      });
    });
    var tabs = cardItem.querySelectorAll('.tab--item');
    tabs.forEach(function (item, index) {
      item.addEventListener('click', function () {
        tabs.forEach(function (tab) {
          tab.classList.remove('active');
        });
        item.classList.add('active');
        var infoElement = cardItem.querySelector('.popup--info');
        var mapElement = cardItem.querySelector('.popup--map');
        if (index === 0 && item.classList.contains('active')) {
          infoElement.classList.add('active');
          mapElement.classList.remove('active');
        } else {
          infoElement.classList.remove('active');
          mapElement.classList.add('active');
        }
      });
    });
  });
}